export default function FaultsRepo($http, appSettings) {

  'ngInject';

  var faultsEndpoint = appSettings.InReachApiAlertsEndpoint + '/configurations/faults';
  var configurationsEndpoint = appSettings.InReachApiAlertsEndpoint + '/configurations';

  this.postFaultConfiguration = function (fault) {
    var endpoint = faultsEndpoint;
    return $http.post(endpoint, fault);
  };

  this.getFaultConfigurationById = function (id) {
    var endPoint = configurationsEndpoint + '/' + id;
    return $http.get(endPoint);
  };

  this.getFaultConfigurationByName = function (name) {
    var endPoint = faultsEndpoint + '/name/' + name;
    return $http.get(endPoint);
  };

  this.getAllFaultConfigurations = function () {
    var endpoint = faultsEndpoint;
    return $http.get(endpoint);
  };

  this.updateFaultConfiguration = function (id, data) {
    var endPoint = configurationsEndpoint + '/' + id;
    return $http.put(endPoint, data);
  };

  this.deleteFaultConfiguration = function (id) {
    var endPoint = configurationsEndpoint + '/' + id;
    return $http.delete(endPoint);
  };

  this.patchFaultConfiguration = function (id, data) {
    var endpoint = configurationsEndpoint + '/' + id;

    return $http.patch(endpoint, data).then(function (response) {
      return response.data;
    }, function (error) {

    });
  };

  this.patchFaultConfigurationEquipment = function (id, data) {
    var endpoint = configurationsEndpoint + '/' + id + '/equipment';
    return $http.patch(endpoint, data);
  };

  this.postFault = function (id, fault) {
    var endpoint = faultsEndpoint + '/' + id + '/triggers';
    return $http.post(endpoint, fault);
  };

  this.deleteFault = function (configId, faultId) {
    var endpoint = configurationsEndpoint + '/' + configId + '/triggers/' + faultId;
    return $http.delete(endpoint);
  };

  this.updateFault = function (id, faultId, fault) {
    var endpoint = faultsEndpoint + '/' + id + '/triggers/' + faultId;
    return $http.put(endpoint, fault);
  };
}